import React, { useState } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  FiHome, FiTruck, FiUsers, FiUploadCloud, FiLogOut,
  FiMenu, FiX, FiUser,
} from 'react-icons/fi';

const AdminLayout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isAdmin = user?.role === 'Admin';

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const navItems = [
    { to: '/admin/dashboard', icon: <FiHome />,        label: 'Dashboard' },
    { to: '/admin/vehicles',  icon: <FiTruck />,       label: 'Vehicles'  },
    ...(isAdmin ? [{ to: '/admin/users', icon: <FiUsers />, label: 'Users' }] : []),
    { to: '/admin/bulk-import', icon: <FiUploadCloud />, label: 'Bulk Import' },
  ];

  return (
    <div className="admin-shell">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Sidebar ── */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <img
              src="/Ajar enterprise logo white.png"
              alt="Ajar | Enterprise"
              style={{ maxHeight: 48, maxWidth: 160, objectFit: 'contain' }}
            />
          </div>
          <button className="sidebar-close d-lg-none" onClick={() => setSidebarOpen(false)}>
            <FiX />
          </button>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-nav-section">Menu</div>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="link-icon">{item.icon}</span>
              <span className="link-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-avatar"><FiUser /></div>
          <div className="user-details">
            <span className="user-name">{user?.username}</span>
            <span className="user-role">{user?.role}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout} title="Logout">
            <FiLogOut />
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <div className="admin-main">
        <header className="admin-topbar">
          <button className="topbar-toggle d-lg-none" onClick={() => setSidebarOpen(true)}>
            <FiMenu />
          </button>
          <span className="topbar-brand d-lg-none">NFC Vehicle</span>
          <div className="topbar-spacer" />
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
